module.exports = __webpack_public_path__ + "img/bg.75e9f40b.jpg";